
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaForward10s as ObiMediaForward10sElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-forward-10s.js';
 
 
 

 
 export const ObiMediaForward10s = createComponent({
   react: React,
   tagName: 'obi-media-forward-10s',
   elementClass: ObiMediaForward10sElement,
   events: {
     
   }
  });
 
 